<script>
  import { apiFetch } from "../lib/api.js";
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import CardContent from "../components/CardContent.svelte"
  import Navbar from "../components/Navbar.svelte"
  import Spinner from "../components/Spinner.svelte"
  import getFecha from "../services/fecha"
  import { formatNumber } from "../services/formatNumber"
  import { descargarTXT } from "../services/txt"
  import { user } from "../stores/user"
  import { BASE_URL } from "../stores/BASE_URL"

  let clientes = []
  let usuarios = []
  let cliente = "0"
  let usuario = "0"
  let consultas = []
  let consultas_descargar = []
  let inicio = "0001-01-01"
  let fin = "0001-01-01"
  let isLoading = false
  let isDownloading = false

  const getClientes = async () => {
    const response = await apiFetch(`${BASE_URL}/cliente.php?action=getClientes`)
    const resp = await response.json()
    clientes = resp.data
  }

  const getUsuarios = async () => {
    const response = await apiFetch(
      `${BASE_URL}/usuario.php?action=getUsuarios&id_cliente=${cliente}&estado_activo=1`,
    )
    const resp = await response.json()
    usuarios = resp.data
  }

  const getConsultas = async () => {
    isLoading = true
    const response = await apiFetch(
      `${BASE_URL}/consulta.php?action=getConsultas&id_cliente=${cliente}&id_usuario=${usuario}&inicio=${inicio}&fin=${fin}`,
    )
    const resp = await response.json()
    consultas = resp.data
    isLoading = false
  }

  const descargarConsultas = async () => {
    isDownloading = true
    const response = await apiFetch(
      `${BASE_URL}/consulta.php?action=getConsultas&id_cliente=${cliente}&id_usuario=${usuario}&inicio=${inicio}&fin=${fin}`,
    )
    const resp = await response.json()
    consultas_descargar = resp.data

    let texto = []
    texto.push(
      "Cliente" +
        "\t" +
        "Usuario" +
        "\t" +
        "Documento" +
        "\t" +
        "Búsqueda" +
        "\t" +
        "Cantidad" +
        "\t" +
        "Ip" +
        "\t" +
        "Fecha",
    )
    for (let d of consultas_descargar) {
      texto.push(
        "\n" +
          d.razon_social +
          "\t" +
          d.usuario +
          "\t" +
          d.documento +
          "\t" +
          d.busqueda +
          "\t" +
          d.cantidad +
          "\t" +
          d.ip +
          "\t" +
          d.fecha,
      )
    }
    const txt = new Blob(texto, {
      type: "text/plain",
    })

    isDownloading = false
    descargarTXT(txt, "reporte_consultas")
  }

  const handleDescargar = () => {
    descargarConsultas()
  }

  const handleBuscar = () => {
    getConsultas()
  }

  getClientes()
  inicio = getFecha()
  fin = getFecha()

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }
  })
</script>

{#if $user}
  <Navbar />
  <div class="container-fluid py-3">
    <CardContent title="Reporte consultas">
      <div class="row g-2 align-items-center">
        <div
          class="col-12 col-sm-12 col-md-6 col-lg-4 d-flex align-items-center gap-2"
        >
          <label for="cliente">Cliente:</label>
          <select
            class="form-select"
            bind:value={cliente}
            on:change={getUsuarios}
          >
            <option value="0">TODOS</option>
            {#each clientes as cliente}
              <option value={cliente.id}>{cliente.razon_social}</option>
            {/each}
          </select>
        </div>
        <div
          class="col-12 col-sm-12 col-md-6 col-lg-4 d-flex align-items-center gap-2"
        >
          <label for="usuario">Usuario:</label>
          <select class="form-select" bind:value={usuario}>
            <option value="0">TODOS</option>
            {#each usuarios as usuario}
              <option value={usuario.id}>{usuario.usuario}</option>
            {/each}
          </select>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-2">
          <input type="date" class="form-control" bind:value={inicio} />
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-2">
          <input type="date" class="form-control" bind:value={fin} />
        </div>
        <div
          class="col-12 col-sm-12 col-md-6 col-lg-12 d-flex align-items-center justify-content-end gap-2"
        >
          {#if isLoading}
            <button class="btn btn-primary" type="button" disabled>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Cargando...
            </button>
          {:else}
            <button
              class="btn btn-primary"
              on:click={handleBuscar}
              disabled={cliente == "0"}
            >
              <i class="bi bi-search" /> Buscar
            </button>
          {/if}
          {#if isDownloading}
            <button class="btn btn-primary" type="button" disabled>
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              Descargando...
            </button>
          {:else}
            <button class="btn btn-primary" on:click={handleDescargar}>
              <i class="bi bi-download" /> Descargar
            </button>
          {/if}
        </div>
      </div>

      <div class="table-responsive mt-3">
        <table class="table table-bordered table-sm table-striped small">
          <thead>
            <tr class="text-secondary fw-normal">
              <th scope="col">Cliente</th>
              <th scope="col">Usuario</th>
              <th scope="col">Documento</th>
              <th scope="col">Búsqueda</th>
              <th scope="col">Cantidad</th>
              <th scope="col">Ip</th>
              <th scope="col">Fecha</th>
            </tr>
          </thead>
          <tbody>
            {#if isLoading}
              <tr>
                <td colspan="7">
                  <Spinner message="Cargando" />
                </td>
              </tr>
            {:else}
              {#if consultas.length === 0}
                <tr>
                  <td colspan="7" class="text-center text-secondary">
                    <p>No hay registros</p>
                  </td>
                </tr>
              {/if}
              {#each consultas as consulta}
                <tr>
                  <td>{consulta.razon_social}</td>
                  <td>{consulta.usuario}</td>
                  <td>{consulta.documento}</td>
                  <td>{consulta.busqueda}</td>
                  <td>{formatNumber(consulta.cantidad)}</td>
                  <td>{consulta.ip}</td>
                  <td>{consulta.fecha}</td>
                </tr>
              {/each}
            {/if}
          </tbody>
        </table>
      </div>
    </CardContent>
  </div>
{/if}
